import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { updateCurrentStep, updateErrors } from '../../../../../../reducers/SellerApp/mandatesSlice';

const StepTab = ({ step, currentStep, validSteps }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(updateErrors({}))
  }, []);

  const isPreviousStepValid = (stepNumber) => {
    return stepNumber === 1 || validSteps.includes(stepNumber - 1);
  }
  
  const handleNavigate = (step) => {  
    if (!isPreviousStepValid(step.number)) return;
    
    dispatch(updateCurrentStep(step.number));
  }
  
  return (
    <div key={step.number} className={`flex gap-2 items-center transition-all ${currentStep.name === step.name ? 'w-full' : 'w-12'} ${isPreviousStepValid(step.number) ? 'cursor-pointer' : ''}`} onClick={() => handleNavigate(step)} data-testid='StepTab'>
      <div>
        <div className={`w-10 h-10 flex items-center justify-center rounded-full transition-all duration-700 ${isPreviousStepValid(step.number) ? 'bg-ih-blue text-white' : 'bg-ih-purple-10 text-ih-blue-50 cursor-not-allowed'}`}>0{step.number}</div>
      </div>

      <div className='flex items-center'>
        <p className={`text-ih-indigo-50 whitespace-nowrap transition-opacity duration-300 overflow-hidden ${currentStep.name === step.name ? 'w-full opacity-100' : 'w-[0%] opacity-0'}`} data-testid='stepName'>{step.name}</p>
        {(currentStep.name !== step.name && step.number !== 3) && <p className='text-ih-purple-40'>-</p>}
      </div>
    </div>
  );
}

export default StepTab;
